import { signalingWaitingUsersUpdated } from 'features/users/actions';
import { call, put, select } from 'redux-saga/effects';
import { bulkComputeEncryptionKeysSaga } from 'features/e2ee/sagas/bulkComputeEncryptionKeysSaga';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { waitingEntryNotificationUpdateRequested } from 'features/notifications/actions';
import { transformToAbstractE2ee } from 'features/e2ee/utils/transformUsersToAbstractE2ee';
import { AbstractE2eeUser } from 'features/e2ee/types';
import { selectMainRoomId } from 'features/breakout-rooms/breakoutRoomsSlice';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectLobbyJoinSoundEnabled } from 'features/room/roomSlice';
import { lobbyJoinSoundManager } from 'utils/audio/LobbyJoinSoundManager';
import { sendWaitingUsersJoinedSaga } from 'features/users/sagas/sendWaitingUsersJoinedSaga';
import { isParticipantsPanelAccessible } from 'features/side-panels/sagas/filterAccessiblePanels';

export function* onWaitingUsersUpdatedSaga(
  action: ReturnType<typeof signalingWaitingUsersUpdated>
) {
  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    const mainRoomId: string = yield select(selectMainRoomId);
    const users: AbstractE2eeUser[] = yield call(
      transformToAbstractE2ee,
      action.payload,
      () => mainRoomId
    );
    yield call(bulkComputeEncryptionKeysSaga, users);
  }

  const canControlRoomEntry: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.controlRoomEntry
  );
  const canAccessParticipantsPanel: boolean = yield call(isParticipantsPanelAccessible);
  const isLobbyJoinSoundEnabled: boolean = yield select(selectLobbyJoinSoundEnabled);

  if (
    canControlRoomEntry &&
    canAccessParticipantsPanel &&
    isLobbyJoinSoundEnabled &&
    action.payload.length > 0
  ) {
    yield call(lobbyJoinSoundManager.triggerSound);
  }

  yield call(sendWaitingUsersJoinedSaga, action.payload);

  yield put(waitingEntryNotificationUpdateRequested());
}
